import config from 'config';

import Fetch from 'tools/Fetch';

import {
    ENTITY_PATH,
} from '../constants';
import {
    ICreatePaymentDto,
} from '../requests/create-payment.dto';
import {
    ICreatePaymentResponse,
} from '../responses/create-payment.response';

export function createPaymentFetch(dto: ICreatePaymentDto): Promise<ICreatePaymentResponse> {
    return new Fetch<ICreatePaymentResponse>({
        url: `${config.CRM_BACKEND_URL}/${ENTITY_PATH}`,
        method: 'POST',
        body: dto,
    })
        .on([200], (body) => {
            return {payment: body};
        })
        .on([400, 401, 500], (body) => {
            return body;
        })
        .exec();
}
